// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA8X-M6BUQzXXzIDIDGp_j5uWcxrAVSKwg",
  authDomain: "independent-service-prov-a0909.firebaseapp.com",
  projectId: "independent-service-prov-a0909",
  storageBucket: "independent-service-prov-a0909.appspot.com",
  messagingSenderId: "905692528335",
  appId: "1:905692528335:web:8ab342efc16edd990001ba",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
